var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("Analysis"))+" ")]},proxy:true}])}),_c('div',{staticClass:"m-5"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.url,"allowtransparency":"true","border":"0","height":"1300px","width":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }